import React from 'react';


const header = (props) => {
  return (
    <header>
      <h1>{props.children}</h1>
    </header>
  );
};

export default header;



// WEBPACK FOOTER //
// ./src/components/header.js